import createDictionary from "../helpers/createDictionary";

export enum USER_TYPE {
  ADMIN = 0,
  MC_ADMIN = 1,
  EMPLOYEE = 2,
  CLIENT = 3,
  HOUSE_IMPORTER = 4,
  COMMERCIAL = 5,
}

const list = [
  {
    id:      USER_TYPE.ADMIN,
    title:   'Суперадминистратор',
    baseUrl: '/admin',
  },
  {
    id:      USER_TYPE.MC_ADMIN,
    title:   'Администратор УК',
    baseUrl: '/mcadmin',
  },
  {
    id:      USER_TYPE.EMPLOYEE,
    title:   'Сотрудник УК',
    baseUrl: '/uc',
  },
  {
    id:      USER_TYPE.CLIENT,
    title:   'Собственник',
    baseUrl: '/client',
  },
  {
    id:      USER_TYPE.HOUSE_IMPORTER,
    title:   'Импортер домов',
    baseUrl: '/house-importer',
  },
  {
    id:      USER_TYPE.COMMERCIAL,
    title:   'Сотрудник КО',
    baseUrl: '/commercial',
  },
];

export default createDictionary({ list, formatLabel: (item) => item.title });

